<template>
	<div class="container">
		<policy-content :content="content"></policy-content>
	</div>
</template>

<script>
import Helper from '@/services/helper';
import PolicyContent from '@/components/gadget/PolicyContent';

export default {
	components: {
		PolicyContent
	},
	data() {
		return {
			content: this.getContent()
		};
	},
	methods: {
		getContent() {
			const title = 'ข้อกำหนดการบริการ (ผู้ขาย) และ/หรือ สัญญาร้านค้า';
			const content = `
				<p>ขอต้อนรับสู่เว็บไซต์ yellowtire และ/หรือ yellowtire mobile application (“เว็บไซต์”) จัดทำและบริหารงานโดย บริษัท เยลโลไทร์ จำกัด (“บริษัทฯ” “เรา” หรือ “ของเรา”) กรุณาอ่านและทำความเข้าใจ “ข้อกำหนดการบริการ (ผู้ขาย)” และ/หรือ “สัญญาร้านค้า” อย่างรอบคอบโดยละเอียด ข้อกำหนดนี้จะใช้บังคับกับการใช้งาน และการเข้าถึง และการใช้บริการแพลตฟอร์มของท่านในฐานะผู้ขาย และเป็นการตกลงระหว่างท่าน (“ผู้ขาย” “ท่าน” “ของท่าน” “ร้านค้า”) และ yellowtire (ในข้อกำหนดนี้ให้หมายถึง “เยลโลไทร์” “บริษัทฯ” “เรา” “พวกเรา”) เมื่อท่านเลือกที่จะใช้บริการในวันที่ท่านคลิกเลือกปุ่ม “สมัครร้านค้า” หรือปุ่มอื่นใดที่คล้ายคลึงกันเพื่อให้ขั้นตอนการสมัครเป็นผู้ขายบนแพลตฟอร์มเสร็จสิ้น (“วันที่มีผลบังคับ”)</p>
				<p>โดยการลงทะเบียนและการใช้บริการ ท่านตกลงที่จะผูกพันตามข้อกำหนดนี้รวมไปถึงนโยบายใดๆ ของแพลตฟอร์มที่แสดงไว้ในเว็บไซด์นี้ หากท่านไม่ตกลงด้วยกับข้อกำหนดเหล่านี้ในการใช้บริการนี้ ห้ามเข้าใช้ และ/หรือใช้แพลตฟอร์มนี้ หรือใช้บริการ</p>
				<ol>
				<li>
				<strong>คำนิยาม</strong>
				<ol>
				<li><strong>“เว็บไซต์” yellowtire</strong> และ/หรือ yellowtire mobile application จัดทำและบริหารงานโดย บริษัท เยลโลไทร์ จำกัด
				</li>
				<li><strong>“แพลตฟอร์ม”</strong> แพลตฟอร์มของเยลโลไทร์บนเว็บไซต์ www.yellowtire.com หรือโดเมนอื่นใดของบริษัทฯเยลโลไทร์ และแอปพลิเคชันโทรศัพท์ของเยลโลไทร์ที่มีอยู่ในระบบปฏิบัติการของโทรศัพท์ (รวมทั้ง iOS และ Andriod) ที่ผู้ขายได้ใส่รายการสินค้าสำหรับขายไว้ภายใต้ข้อกำหนดนี้และเมื่อผู้ซื้อสามารถซื้อสินค้าดังกล่าวได้
				</li>
				<li><strong>“บริษัทฯ” “เรา” “ของเรา”</strong> บริษัท เยลโลไทร์ จำกัด
				</li>
				<li><strong>“บริษัทในเครือ”</strong> หน่วยงานใดซึ่งควบคุมโดย หรือควบคุม คู่สัญญาหรือบริษัทในเครือใดๆ หรือบริษัทย่อยของคู่สัญญาไม่ว่าโดยตรงหรือโดยอ้อม
				</li>
				<li><strong>“ผู้ขาย” “ท่าน” “ของท่าน” “ร้านค้า”</strong> ร้านค้าที่สมัครใช้บริการแพลตฟอร์มในฐานะผู้ขาย
				</li>
				<li><strong>“ผู้ซื้อ”</strong> บุคคลภายนอกผู้ซื้อสินค้าบนแพลตฟอร์ม
				</li>
				<li><strong>“ค่าธรรมเนียมการดำเนินการ/ค่าธรรมเนียมการไม่ปฏิบัติตามสัญญา”</strong> ค่าธรรมเนียมที่ระบุไว้ในหน้าร้านค้าและที่เรียกเก็บได้กับท่านสำหรับการไม่ปฏิบัติตามข้อกำหนดนี้ นโยบายหรือกฎหมายที่เกี่ยวข้องหรือไม่ว่าด้วยเหตุผลใด
				</li>
				<li><strong>“สัญญาผู้ซื้อ” “คำสั่งซื้อ”</strong> คำขอที่ทำขึ้นโดยผู้ซื้อบนแพลตฟอร์มเพื่อซื้อสินค้าใด และเป็นคำสั่งซื้อที่ยอมรับโดยผู้ขาย ซึ่งบังคับภายใต้ข้อกำหนดการขายของเยลโลไทร์
				</li>
				<li><strong>“ใบสั่งซื้อของลูกค้า”</strong> การสั่งซื้อจากลูกค้า ซึ่งถูกส่งมายังบริษัทฯ ผ่านทางเว็บไซต์ yellowtire โดยการกรอกข้อมูลในกระบวนการทำคำสั่งซื้อที่ปรากฏในเว็บไซต์ yellowtire ตามรูปแบบและขั้นตอนที่กำหนดไว้ในเว็บไซต์ yellowtire
				</li>
				<li><strong>“ใบยืนยันการสั่งซื้อ”</strong> การยืนยันเป็นลายลักษณ์อักษรจากบริษัทฯ ถึงการยอมรับใบสั่งซื้อสินค้าของลูกค้า ที่บริษัทฯ ได้ออกให้ก่อนวันจัดหาสินค้าให้ลูกค้า ใบยืนยันการสั่งซื้อนี้โดยหมายรวมถึง การส่งทางจดหมายอิเล็กทรอนิกส์ ทางโทรเลข ทางสายเคเบิ้ล ทางโทรสาร หรือวิธีการสื่อสารใดๆ ในทำนองเช่นว่านั้น
				</li>
				<li><strong>“โทษในการยกเลิกคำสั่งซื้อ”</strong> ค่าใช้จ่ายที่เกิดขึ้นสำหรับการยกเลิกคำสั่งซื้อ โทษในการยกเลิกคำสั่งซื้อจะมีจำนวนเท่าที่ระบุไว้ในหน้าร้านค้า
				</li>
				<li><strong>“คำสั่งซื้อที่ยกเลิก”</strong> คำสั่งซื้อที่ถูกยกเลิกหรือปฏิเสธโดยท่าน หรือยกเลิกเนื่องมาจากการที่ท่านไม่มีความสามารถในการดำเนินการตามข้อกำหนดข้อใดของข้อกำหนดฉบับนี้
				</li>
				<li><strong>“ข้อเรียกร้อง”</strong> สิทธิยึดหน่วง ความเสียหาย สูญหาย ความรับผิด หน้าที่ โทษ ค่าปรับ ค่าธรรมเนียม ข้อเรียกร้อง คดีความ การร้องขอ การคุ้มครอง คำตัดสิน คำฟ้อง การดำเนินคดี ต้นทุน การชำระเงินหรือค่าใช้จ่ายไม่ว่าชนิดใดหรือในลักษณะใด (รวมไปถึงข้อเรียกร้องของบุคคลภายนอก ค่าทนายความที่เหมาะสม ค่าธรรมเนียมที่ปรึกษา ค่าธรรมเนียมผู้เชี่ยวชาญและค่าธรรมเนียมการดำเนินคดีความ)
				</li>
				<li><strong>“ค่าคอมมิชชั่น”</strong> ค่าคอมมิชชั่นมีอัตราส่วนแบ่งจากการขายสินค้า ตามที่ระบุไว้ในหน้าร้านค้า
				</li>
				<li><strong>“ค่าธรรมเนียม”</strong> ค่าธรรมเนียมการบริการที่ท่านต้องชำระให้แก่เยลโลไทร์สำหรับข้อกำหนดการบริการจะถูกคำนวน ตามที่ระบุไว้ในหน้าร้านค้า
				</li>
				<li><strong>“ค่าธรรมเนียมการชำระเงิน”</strong> ค่าธรรมเนียมที่คำนวนโดยอัตราร้อยละของเงินจากการขายสุทธิ สำหรับการชำระเงิน สำหรับบริการการชำระเงิน
				</li>
				<li><strong>“ข้อมูลที่เป็นความลับ”</strong> ข้อมูลใดที่คู่สัญญาหรือบริษัทในเครือของคู่สัญญาในข้อกำหนดนี้เป็นเจ้าของ ที่ถูกเปิดเผยให้แก่คู่สัญญาหรือบริษัทให้เครือของคู่สัญญาอีกฝ่าย ไม่ว่าได้ระบุไว้ว่าเป็นข้อมูลที่เป็นความลับหรือไม่ จะต้องถือว่าเป็นข้อมูลที่เป็นความลับ โดยข้อมูลดังกล่าวไม่รวมถึงข้อมูลที่ผู้รับข้อมูลรู้อยู่ก่อนแล้ว หรือที่กลายเป็นข้อมูลสาธารณะโดยวิธีการที่ไม่ได้เป็นความผิดของผู้รับข้อมูล หรือเป็นข้อมูที่ผู้รับเป็นผู้พัฒนาขึ้นมาเองแต่เพียงผู้เดียว หรือ เป็นข้อมูลที่ได้มาโดยถูกต้องตามกฎหมายและมีส่งให้แก่ผู้รับโดยบุคคลภายนอก
				</li>
				<li><strong>“ภาษีโภคภัณฑ์”</strong> ภาษีโภคภัณฑ์ใดที่เกิดขึ้น รวมไปถึงแต่ไม่จำกัดเพียงภาษีของสินค้าและบริการ ภาษีมูลค่าเพิ่ม ภาษีขายและภาษีบริการ หรือสิ่งที่เทียบเท่าและมีการแก้ไขเป็นครั้งคราว
				</li>
				<li><strong>“เหตุสุดวิสัย”</strong> เหตุการณ์หรือสาเหตุใดที่เหนือความควบคุมที่สมเหตุผลของคู่สัญญาโดยรวมถึงแต่ไม่จำกัดเพียง ปรากฎการณ์ธรรมชาติ สงคราม การก่อวินาศกรรม การจลาจล การรบกวนการจราจร ประท้วง การนัดหยุดงาน เหตุฉุกเฉินที่ประกาศโดยรัฐบาล
				</li>
				<li><strong>“การจัดการสินค้าสำเร็จตามสัญญาผู้ซื้อ”</strong> สถานะของคำสั่งซื้อที่แสดงว่า “ส่งแล้ว” และ/หรือ “ติดตั้งแล้ว” ในหน้าร้านค้าหรือคำอื่นใดที่เยลโลไทร์ถือว่าได้มีการดำเนินการโดยท่านแล้ว
				</li>
				<li><strong>“รูปแบบการจัดการสินค้า”</strong> รูปแบบของการจัดการสินค้า คำสั่งซื้อของสินค้าที่จับต้องได้และสินค้าที่ตกลงร่วมกันโดยคู่สัญญาที่จะ “จัดส่งสินค้า” และ/หรือ “ติดตั้งสินค้า” ตามที่ตกลงกัน
				</li>
				<li><strong>“สิทธิในทรัพย์สินทางปัญญา”</strong> สิทธิบัตรและลิขสิทธิ์ สิทธิทางศีลธรรม เครื่องหมายการค้า สิทธิออกแบบ สิทธิในหรือที่เกี่ยวข้องกับฐานข้อมูล และ/หรือข้อมูลที่เป็นความลับ สิทธิที่เกี่ยวข้องกับโดเมนเนม และสิทธิในทรัพย์สินทางปัญญาอื่นใด (ที่จดทะเบียนและไม่ได้จดทะเบียน) ทั่วโลก
				</li>
				<li><strong>“ข้อมูลส่วนบุคคล”</strong> ข้อมูลส่วนบุคคลใดที่นิยามไว้ในกฎหมายคุ้มครองข้อมูลส่วนบุคคลที่บังคับใช้ และระเบียบที่เกี่ยวข้องแต่ไม่จำกัดเพียงกับเยลโลไทร์ หรือบริษัทในเครือของเยลโลไทร์ หรือเจ้าพนักงาน ลูกจ้าง กรรมการ ผู้รับเหมา หุ้นส่วน ตัวแทน ผู้รับจ้างช่วงและตัวแทนทีเกี่ยวข้องและผู้ซื้อ
				</li>
				<li><strong>“นโยบาย”</strong> กฎ แนวทาง ข้อกำหนดและเงื่อนไข ที่บังคับใช้กับผู้ขายและผู้ซื้อสำหรับการใช้บริการแพลตฟอร์ม หน้าร้านค้า เครื่องมือและทรัพย์สินอื่นของเยลโลไทร์ที่อาจมีขึ้นบนแพลตฟอร์ม หรือหน้าร้านค้าหรือที่อาจมีการสื่อสารโดยเยลโลไทร์เป็นครั้งคราว รวมไปถึงนโยบายความเป็นส่วนตัว
				</li>
				<li><strong>“สินค้า”</strong> สินค้าหรือบริการ ที่เสนอขายโดยผู้ขายแก่ผู้ซื้อตามข้อกำหนดนี้
				</li>
				<li><strong>“บัญชีผู้ขาย”</strong> บัญชีที่ท่านได้สร้างกับเยลโลไทร์สำหรับการเข้าถึงแพลตฟอร์ม และเครื่องมือ และเป็นที่ที่ท่านจะสามารถดูรายการรับเงินจากการขายได้
				</li>
				<li><strong>“หน้าร้านค้า”</strong> เครื่องมือใดที่เยลโลไทร์เสนอให้แก่ผู้ขายเพื่อให้ผู้ขายปฏิบัติการบนแพลตฟอร์ม และเข้าถึงซึ่งการบริการ
				</li>
				<li><strong>“ค่าธรรมเนียมการขนส่ง”</strong> ค่าธรรมเนียมที่เรียกเก็บโดยเยลโลไทร์จากผู้ขาย สำหรับกรณีที่เยลโลไทร์เป็นผู้ประสานงานในการขนส่ง ตามที่ระบุไว้หน้าร้านค้า
				</li>
				<li><strong>“ข้อกำหนด”</strong> ตามที่นิยามไว้ในคำนำ
				</li>
				<li><strong>“เครื่องมือ”</strong> เครื่องมือใดที่เยลโลไทร์ให้แก่ท่านในส่วนที่เกี่ยวกับการเข้าถึงและการใช้บริการของท่าน
				</li>
				<li><strong>“วันทำการ”</strong> วันอื่นนอกเหนือจากวันเสาร์ วันอาทิตย์ และวันหยุดของประเทศ หรือวันหยุดนักขัตฤกษ์ วันที่ธนาคารโดยทั่วไปเปิดทำการในประเทศไทย
				</li>
				</ol>
				</li>
				<li>
				<strong>การยอมรับข้อกำหนดและเงื่อนไข</strong>
				<ol>
				<li><strong>การยอมรับข้อกำหนดและเงื่อนไข </strong>บุคคลใดที่ต้องการที่จะเข้าถึงแพลตฟอร์มเยลโลไทร์และใช้บริการเพื่อที่จะขายสินค้า จะต้องยอมรับซึ่งข้อกำหนดการบริการ (ผู้ขาย) และ/หรือ สัญญาร้านค้านี้ ท่านจะต้องส่งมอบสำเนาเอกสารใดที่เยลโลไทร์ร้องขอ ในขณะเข้าผูกพันโดยการอัพโหลดเอกสารดังกล่าวไปยังหน้าร้านค้า เยลโลไทร์สามารถตรวจสอบเอกสาร และข้อมูลอื่นใดที่ถูกส่งเข้ามาก่อนที่จะดำเนินการเกี่ยวกับการชำระเงิน
				</li>
				<li><strong>การเปลี่ยนแปลง</strong> เยลโลไทร์สามารถเปลี่ยนแปลงข้อกำหนด และค่าธรรมเนียมใดๆ ขั้นตอนและนโยบายที่กำหนด เกี่ยวกับการให้บริการ แพลตฟอร์มและหน้าร้านค้า ไม่ว่าในเวลาใด โดยการเปลี่ยนแปลงดังกล่าวจะมีผลบังคับเมื่อเยลโลไทร์ได้แจ้งให้ผู้ขายทราบ และการที่ท่านยังคงใช้บริการ ใช้แพลตฟอร์ม และ/หรือหน้าร้านค้าต่อไปหลังจากการเยลโลไทร์ได้แจ้งให้ผู้ขายทราบ จะถือว่าท่านได้ยอมรับซึ่งการเปลี่ยนแปลงดังกล่าวแล้ว หากท่านไม่เห็นด้วยซึ่งการเปลี่ยนแปลงใดๆ ดังกล่าว ท่านจะต้องหยุดใช้บริการ แพลตฟอร์มและหน้าร้านค้าดังกล่าว (เว้นแต่การใช้ที่จำเป็นที่กำหนดไว้ในข้อกำหนด) และติดต่อบริษัท เยลโลไทร์ จำกัด ที่หน้าร้านค้าเพื่อที่จะระงับบัญชีการขายของท่านเมื่อมีการเลิกข้อกำหนดดังกล่าว เพื่อให้ปราศจากข้อสงสัย ข้อกำหนดฉบับที่ใหม่กว่าจะมีผลบังคับเหนือกว่าข้อกำหนดฉบับเก่า เว้นแต่ตกลงไว้เป็นอย่างอื่นโดยข้อกำหนดการบริการ (ผู้ขาย) และ/หรือ สัญญาร้านค้านี้
				</li>
				</ol>
				</li>
				<li>
				<strong>การบริการ ค่าคอมมิชชั่น และ ค่าธรรมเนียม</strong>
				<ol>
				<li><strong>แพลตฟอร์ม </strong>เยลโลไทร์ให้บริการแพลตฟอร์มแก่ผู้ขายในการนำเสนอสินค้าสำหรับขายแก่ผู้ซื้อ และเพื่อให้ผู้ขายสามารถดำเนินธุรกรรมกับผู้ซื้อจนแล้วเสร็จ เว้นแต่จะกำหนดไว้ในข้อกำหนดนี้และเท่าที่อนุญาตให้กระทำได้ตามกฎหมายที่เกี่ยวข้อง เยลโลไทร์ไม่มีส่วนเกี่ยวข้องในการดำเนินธุรกรรมระหว่างผู้ขายและผู้ซื้อ และเยลโลไทร์ไม่มีหน้าที่ที่จะต้องตรวจสอบความถูกต้อง ความสมบูรณ์และความชอบด้วยกฎหมายของรายละเอียดเนื้อหาที่ผู้ขายประกาศลงไว้บนแพลตฟอร์ม
				</li>
				<li><strong>การให้บริการ </strong>บริการที่ดำเนินการโดยเยลโลไทร์ (หรือผู้ให้บริการที่เยลโลไทร์กำหนด) ภายใต้ข้อกำหนดนี้จะถูกแบ่งตามประเภทดังต่อไปนี้
				<ol>
				<li><strong>การบริการทั่วไป (“การบริการทั่วไป”) ประกอบด้วย</strong>
				<ol>
				<li>ให้บริการสนับสนุนช่วยเหลือเพื่อให้ท่านสามารถสร้างรายการสินค้าและเผยแพร่รายละเอียดเนื้อหาเกี่ยวกับสินค้าที่ท่านจะเสนอขายบนแพลตฟอร์ม
				</li>
				<li>ให้บริการแพลตฟอร์มเพื่อให้ท่านเสนอขายสินค้า
				</li>
				<li>ให้บริการดูแลลูกค้าภายในขอบเขตที่ตกลง รวมไปถึงประสานงานและตอบข้อสงสัยของลูกค้าและดำเนินการเกี่ยวกับการคืนสินค้า
				</li>
				<li>ประมวลผลคำสั่งซื้อ
				</li>
				<li>ประสานงานเกี่ยวกับการบริการติดตั้งและขนส่งสินค้า
				</li>
				<li>การเก็บรวบรวม สรุปยอดขายและการดำเนินการเกี่ยวกับรายได้จากขายทั้งหมด
				</li>
				<li>การบริการเสริมอื่นๆ ที่เกี่ยวข้องของกับการให้บริการ หรือ การขายสินค้า
				</li>
				<li>การบริการทั่วไปนี้รวมไปถึงการที่เยลโลไทร์ให้ข้อมูลแก่ท่านในส่วนที่เกี่ยวกับคำสั่งซื้อแต่ละคำสั่งเท่าที่จำเป็นภายใต้ข้อกำหนดนี้ ท่านตกลงว่าเยลโลไทร์สามารถให้ซึ่งสำเนาอิเล็กทรอนิกส์ของเอกสารแก่ท่านได้ เช่น ใบกำกับภาษี ใบเสร็จ ใบลดหนี้ ใบเพิ่มหนี้ หรือเอกสารอื่นใดสำหรับการปฏิบัติตามกฎหมายที่เกี่ยวข้อง
				</li>
				</ol>
				</li>
				<li><strong>การบริการเพิ่มเติม (“การบริการเพิ่มเติม”) </strong>เราอาจจะเสนอทางเลือกให้ท่าน ในการซื้อสินค้าและบริการที่เราและหรือบุคคลภายนอกจัดหาให้แก่ท่าน ภายใต้ข้อกำหนด และเงื่อนไขที่ตกลงตามนโยบาย และ/หรือในสัญญาแยกต่างหาก เช่น กิจกรรมทางการค้า ( Sales Traffic Activities) โดยเราสามารถกำหนดและแก้ไขซึ่งข้อกำหนดเกี่ยวกับการให้บริการเพิ่มเติมได้ โดยการเปลี่ยนแปลงดังกล่าวจะมีผลบังคับทันทีหลังจากที่ได้มีการประกาศซึ่งการดังกล่าวบนแพลตฟอร์ม หน้าร้านค้า หรือไม่ว่าการแจ้งให้รูปแบบใดต่อท่าน
				</li>
				</ol>
				</li>
				<li><strong>ค่าคอมมิชชั่น </strong>เยลโลไทร์สงวนสิทธิ์ในการเปลี่ยนแปลงอัตราค่าคอมมิชชั่นตามที่ระบุไว้ในหน้าร้านค้า เยลโลไทร์อาจลด/เพิ่มอัตราค่าคอมมิชชั่น โดยจะแจ้งให้ทราบในหน้าร้านค้า
				</li>
				<li><strong>ค่าธรรมเนียม </strong>เยลโลไทร์มีสิทธิในการคิดและเรียกเก็บค่าธรรมเนียมจากท่านตามข้อกำหนดด้านการให้บริการ เยลโลไทร์อาจปรับปรุงค่าธรรมเนียมการชำระเป็นครั้งคราว โดยการคำนวณค่าธรรมเนียมการชำระเงินจะถูกระบุไว้ในหน้าร้านค้า
				</li>
				<li><strong>ตารางแสดงค่าคอมมิชชั่น และ ค่าธรรมเนียม</strong>
				<p><strong>5.1 ตารางแสดง ค่าธรรมเนียมการขาย และ ค่าธรรมเนียม แบบติดตั้ง</strong></p>
				<table>
				<tbody>
				<tr>
				<td colspan="2"><strong>ค่าธรรมเนียมการชำระเงินและค่าธรรมเนียมการขาย</strong></td>
				<td class="text-center"><strong>ค่าธรรมเนียมการขาย</strong></td>
				<td class="text-center"><strong>ค่าธรรมเนียมการชำระเงิน</strong></td>
				</tr>
				<tr>
				<td>ผ่านบัตรเครดิต / เดบิต</td>
				<td class="text-center"><strong>8%</strong></td>
				<td class="text-center">3%</td>
				<td class="text-center">5%</td>
				</tr>
				<tr>
				<td>โอนเงิน (QR/Prompt pay)</td>
				<td class="text-center"><strong>6%</strong></td>
				<td class="text-center">3%</td>
				<td class="text-center">3%</td>
				</tr>
				<tr>
				<td>ผ่อน 0% 3 เดือน</td>
				<td class="text-center"><strong>9%</strong></td>
				<td class="text-center">3%</td>
				<td class="text-center">6%</td>
				</tr>
				<tr>
				<td>ผ่อน 0% 4 เดือน</td>
				<td class="text-center"><strong>10%</strong></td>
				<td class="text-center">3%</td>
				<td class="text-center">7%</td>
				</tr>
				<tr>
				<td>ผ่อน 0% 6 เดือน</td>
				<td class="text-center"><strong>11%</strong></td>
				<td class="text-center">3%</td>
				<td class="text-center">8%</td>
				</tr>
				<tr>
				<td>ผ่อน 0% 10 เดือน</td>
				<td class="text-center"><strong>13%</strong></td>
				<td class="text-center">3%</td>
				<td class="text-center">10%</td>
				</tr>
				<tr>
				<td>ผ่อนมีดอกเบี้ย</td>
				<td class="text-center"><strong>6%</strong></td>
				<td class="text-center">3%</td>
				<td class="text-center">3%</td>
				</tr>
				<tr>
				<td>มัดจำ 1,000 บาท</td>
				<td class="text-center"><strong>600 บาท</strong></td>
				<td class="text-center">-</td>
				<td class="text-center">600 บาท</td>
				</tr>
				</tbody>
				</table>
				<p><strong>5.2 ตารางแสดง ค่าธรรมเนียมการขาย และ ค่าธรรมเนียม แบบจัดส่ง</strong></p>
				<table>
				<tbody>
				<tr>
				<td colspan="2"><strong>ค่าธรรมเนียมการชำระเงินและค่าธรรมเนียมการขาย</strong></td>
				<td class="text-center"><strong>ค่าธรรมเนียมการขาย</strong></td>
				<td class="text-center"><strong>ค่าธรรมเนียมการชำระเงิน</strong></td>
				</tr>
				<tr>
				<td>ผ่านบัตรเครดิต / เดบิต</td>
				<td class="text-center"><strong>8%</strong></td>
				<td class="text-center">3%</td>
				<td class="text-center">5%</td>
				</tr>
				<tr>
				<td>โอนเงิน (QR/Prompt pay)</td>
				<td class="text-center"><strong>6%</strong></td>
				<td class="text-center">3%</td>
				<td class="text-center">3%</td>
				</tr>
				<tr>
				<td>ผ่อน 0% 3 เดือน</td>
				<td class="text-center"><strong>9%</strong></td>
				<td class="text-center">3%</td>
				<td class="text-center">6%</td>
				</tr>
				<tr>
				<td>ผ่อน 0% 4 เดือน</td>
				<td class="text-center"><strong>10%</strong></td>
				<td class="text-center">3%</td>
				<td class="text-center">7%</td>
				</tr>
				<tr>
				<td>ผ่อน 0% 6 เดือน</td>
				<td class="text-center"><strong>11%</strong></td>
				<td class="text-center">3%</td>
				<td class="text-center">8%</td>
				</tr>
				<tr>
				<td>ผ่อน 0% 10 เดือน</td>
				<td class="text-center"><strong>13%</strong></td>
				<td class="text-center">3%</td>
				<td class="text-center">10%</td>
				</tr>
				<tr>
				<td>ผ่อนมีดอกเบี้ย</td>
				<td class="text-center"><strong>6%</strong></td>
				<td class="text-center">3%</td>
				<td class="text-center">3%</td>
				</tr>
				</tbody>
				</table>
				<p><strong>การชำระค่าบริการ </strong>เว้นแต่ได้มีการตกลงไว้เป็นลายลักษณ์อักษร การชำระเงินตามใบแจ้งหนี้สำหรับค่าคอมมิชชั่น ค่าธรรมเนียม ค่าธรรมเนียมการเงิน ค่าขนส่ง (ถ้ามีในกรณีที่ เยลโลไทร์เป็นผู้ประสานงานการจัดส่ง) จะเรียกเก็บโดยหักจากเงินของท่านที่อยู่ในบัญชีผู้ขายที่ท่านมีกับเยลโลไทร์</p>
				<p>เยลโลไทร์จะชำระเงินให้กับท่านโดยหักค่าใช้จ่ายตามข้อกำหนดในข้อ 3.3 ค่าคอมมิชชั่น และ ข้อ 3.4 ค่าธรรมเนียม เว้นแต่จะตกลงอย่างอื่นเป็นลายลักษณ์อักษร สถานะคำสั่งซื้อในหน้าร้านค้าอาจมีความล่าช้าในช่วงสุดสัปดาห์ วันหยุดนักขัตฤกษ์ หรือล่าช้าจากเหตุจากบุคคลที่สาม หรือปัจจัยอื่นๆ นอกเหนือจากการควบคุมของเยลโลไทร์</p>
				</li>
				</ol>
				</li>
				<li>
				<strong>รายได้จากการขาย – การชำระเงิน</strong>
				<ol>
				<li><strong>การชำระเงิน</strong> ท่านอนุญาตให้เยลโลไทร์ (หรือผู้ให้บริการที่เยลโลไทร์กำหนด)
				<ol>
				<li>เก็บรวบรวมกระบวนการการขายและผลรวมทั่วไปใดๆ ที่ถึงกำหนดชำระหรือที่ค้างชำระภายใต้ข้อกำหนดนี้และถือไว้ซึ่งสิ่งดังกล่าว
				</li>
				<li>คำนวนและดำเนินการชำระเงิน การคืนเงิน ในกรณีลูกค้ากรณียกเลิกคำสั่งซื้อ
				</li>
				<li>ส่งจำนวนเงินสุทธิให้ร้านค้าตามบัญชีที่สมัครไว้กับเยลโลไทร์ เงินสุทธิคือยอดการใช้บริการ หัก ค่าคอมมิชชั่น และ ค่าธรรมเนียม เรียบร้อยแล้ว
				</li>
				</ol>
				</li>
				<li><strong>การดำเนินการเกี่ยวกับรายได้จากการขายของร้านค้า</strong> ท่านตกลงว่าผู้ซื้อได้ดำเนินการให้เป็นที่พอใจตามหน้าที่ของตนที่มีต่อท่านภายใต้สัญญาของผู้ซื้อ เมื่อเยลโลไทร์ (หรือผู้ให้บริการที่เยลโลไทร์กำหนด) ได้รับรายได้จากการขายหน้าที่ของเยลโลไทร์ (หรือผู้ให้บริการที่เยลโลไทร์กำหนด) ในการส่งเงินที่ได้รับโดยเราในนามของท่านนั้นจำกัดเพียงจำนวนเงินสุทธิ (ซึ่งมาจากรายได้จากการขายหักด้วยผลรวมใดที่ท่านค้างชำระต่อเยลโลไทร์ บริษัทในเครือของเยลโลไทร์หรือบุคคลภายนอกในส่วนที่เกี่ยวข้องกับการใช้แพลตฟอร์มหรือธุรกรรมบนแพลตฟอร์มของท่าน และยังอยู่ภายใต้บังคับของการเรียกให้ชำระคืนส่วนที่เยลโลไทร์ออกเงินไปก่อน การเรียกคืนเงินที่ชำระไปแล้ว การคืนเงิน การหักเงินไว้สำหรับกรณีมีข้อเรียกร้องที่อาจเกิดขึ้นได้ และ/หรือการหักเงินที่เป็นไปตามข้อกำหนดและนโยบายนี้ การชำระเงินนี้เป็นสิทธิที่ไม่มีหลักประกัน เพื่อให้เป็นการปราศจากข้อสงสัย ท่านจะไม่ได้รับดอกเบี้ยหรือรายรับอื่นใดจากรายได้จากการขายหรือจำนวนเงินสุทธิ
				</li>
				<li><strong>ไม่มีส่วนรับผิดชอบ</strong> เยลโลไทร์ (หรือผู้ให้บริการที่เยลโลไทร์กำหนด) ไม่ต้องรับผิดชอบเกี่ยวกับความถูกต้องตามกฎหมายของธุรกรรมที่เกิดขึ้นระหว่างผู้ขายและผู้ซื้อในส่วนที่เกี่ยวข้องกับคำสั่งซื้อที่ดำเนินการผ่านแพลตฟอร์ม
				</li>
				<li><strong>การเยียวยาความเสียหายและการไม่ถือเป็นการสละสิทธิ</strong> เยลโลไทร์ (หรือร้องขอให้ผู้ให้บริการที่เยลโลไทร์ดำเนินการ) อาจทำให้ช้าลง เลื่อน หรือยกเลิกการชำระเงินใดๆ หากร้านค้ามีการละเมิดข้อกำหนดข้อใดของข้อกำหนดนี้หรือนโยบาย และ/หรือการไม่สามารถดำเนินการซึ่งหน้าที่ใดๆ ที่ถึงกำหนดที่จะต้องดำเนินการภายใต้ข้อกำหนดนี้ และเยลโลไทร์ ได้แจ้งให้ร้านทราบถึงการละเมิดข้อกำหนดดังกล่าวการชำระเงินใดๆ โดยเยลโลไทร์แก่ท่านนั้น ไม่ว่าในกรณีใดๆ จะไม่ถูกพิจารณาเป็นการที่เยลโลไทร์สละสิทธิของเยลโลไทร์ภายใต้ข้อกำหนดฉบับนี้
				</li>
				<li><strong>ดอกเบี้ยการชำระเงินล่าช้า</strong> โดยไม่เป็นการตัดสิทธิและการเยียวยาอื่นใดที่เยลโลไทร์มีต่อท่าน หากผลรวมการชำระเงินใดๆ ของท่านแก่เยลโลไทร์ที่อยู่ภายใต้ข้อกำหนดนี้นั้นได้ถึงกำหนดชำระและยังไม่มีการชำระ ท่านต้องชำระให้แก่เยลโลไทร์ซึ่งดอกเบี้ยการชำระเงินล่าช้า คำนวนเป็นรายวันนับแต่วันถึงกำหนดชำระจนกว่าเยลโลไทร์จะได้รับการชำระเงินดังกล่าวจริง
				</li>
				<li><strong>ภาษีหัก ณ ที่จ่าย</strong> ภายในขอบเขตของกฎหมายที่เกี่ยวข้อง เยลโลไทร์ และร้านค้า สามารถ หัก ณ ที่จ่ายซึ่งภาษี อากร ค่าธรรมเนียมหรือค่าใช้จ่ายอื่นใดทั้งหมดที่เกี่ยวข้องกับคำสั่งซื้อ การชำระเงินหรือการอื่นใดๆ ภายใต้ข้อกำหนดนี้หรือสัญญาผู้ซื้อ
				</li>
				</ol>
				</li>
				<li>
				<strong>การเข้าถึงการบริการและเครื่องมือ</strong>
				<ol>
				<li><strong>การเข้าถึงบัญชีผู้ขาย</strong> ท่านต้องรับผิดชอบในการให้และอนุญาตให้บุคคลที่ท่านอนุญาตให้สามารถเข้าถึงบัญชีผู้ขายของท่านและรับรองว่าบุคคลใดดังกล่าวที่กรอกรายละเอียดหรือลงลายมือชื่อในเอกสารใดๆ ใช้บัญชีผู้ขายหรือจัดการสินค้าในนามของท่าน (นอกเหนือจากพนักงานของเยลโลไทร์ บุคคลตามสัญญาหรือตัวแทนที่มอบอำนาจมาโดยเฉพาะโดยเยลโลไทร์) นั้นเป็นบุคคลผู้มีอำนาจและมีสิทธิโดยสมบูรณ์ในการดำเนินการดังกล่าวในนามของท่าน โดยการกระทำใดที่ทำไปโดยบุคคลใดที่เข้าถึงหรือใช้บัญชีผู้ขาย การบริการหรือเครื่องมือในนามของท่านนั้นจะถือว่าเป็นผู้ได้รับอนุญาตเว้นแต่ท่านได้บอกกล่าวเยลโลไทร์ล่วงหน้าว่าบุคคลดังกล่าวไม่มีสิทธิ
				</li>
				<li><strong>ความถูกต้องของข้อมูลของบัญชีผู้ขาย</strong> ท่านต้องเป็นผู้รับผิดชอบในการรับรองว่าข้อมูลทั้งหมด (รวมไปถึงอีเมล์และรายละเอียดบัญชีธนาคาร) ที่ให้ไว้หรือแสดงไว้โดยท่านหรือบุคคลที่ท่านอนุญาตในบัญชีผู้ขายนั้นถูกต้องและสมบูรณ์อยู่ตลอดเวลา ท่านจะเป็นผู้ที่ต้องรับผลที่ตามมาทั้งหมดที่เกิดขึ้นจากข้อมูลที่ไม่ถูกต้องที่ให้ไว้ทั้งหมดและเยลโลไทร์จะไม่มีส่วนรับผิดชอบใดๆ ในการตรวจสอบข้อมูลดังกล่าว หรือดำเนินการใดๆ เพื่อแก้ไขเหตุการณ์ดังกล่าว หรือส่งเงินให้แก่ท่าน
				</li>
				</ol>
				</li>
				<li>
				<strong>การจัดการสินค้าตามคำสั่งซื้อ</strong>
				<ol>
				<li><strong>การติดตั้งสินค้าโดยผู้ขาย</strong> เป็นกรณีที่ท่านเป็นผู้รับผิดชอบในการเตรียมสินค้า และติดตั้งสินค้าให้กับผู้ซื้อ
				<ol>
				<li>ท่านต้องเตรียมสินค้าภายใต้สัญญาผู้ซื้อตามที่ระบุไว้ในคำสั่งซื้อ และติดตั้งสินค้าในเวลาที่กำหนดไว้เมื่อผู้ซื้อได้นำยานพาหนะมาติดตั้งสินค้า หากท่านไม่สามารถปฏิบัติตามรายละเอียดที่กำหนดไว้ เยลโลไทร์อาจแก้ไขคำสั่งซื้อ และ/หรือยกเลิกคำสั่งซื้อนั้น
				</li>
				<li>ท่านจะต้องอัพเดทรายละเอียดการติดตั้งบนหน้าร้านค้าภายในกรอบระยะเวลาที่กำหนดไว้ในนโยบาย ท่านจะต้องดำเนินการใดๆ เพื่อให้แน่ใจได้ว่าเยลโลไทร์จะได้รับข้อมูลการติดตามสถานะการติดตั้งของคำสั่งซื้อที่เป็นปัจจุบันตลอดเวลา
				</li>
				<li>ท่านต้องหยุดหรือยกเลิกคำสั่งซื้อใดๆ หากมีการแจ้งให้ดำเนินการจากเยลโลไทร์
				</li>
				<li>ท่านต้องรับผิดชอบ และรับความเสี่ยงรวมถึงความรับผิดทั้งหมดสำหรับการติดตั้งสินค้าที่เกิดกับยานพาหนะของลูกค้า รวมถึงการควบคุมคุณภาพสินค้า การติดตั้งสินค้า และรับประกันสินค้า (หากมี)
				</li>
				<li>เยลโลไทร์ไม่มีความรับผิดใดๆ เกี่ยวกับสินค้า เกี่ยวกับการติดตั้งสินค้า หรือความเสียหายที่เกิดจากการติดตั้งของผู้ขาย ความเสียหายทั้งหมดผู้ขายตกลงที่จะเป็นผู้รับผิดชอบทั้งหมด
				</li>
				</ol>
				</li>
				<li><strong>การขนส่งโดยผู้ขาย </strong>เป็นกรณีที่ท่านเป็นผู้รับผิดชอบในการขนส่งสินค้าแก่ผู้ซื้อเอง โดยใช้การบริการส่งสินค้าที่จัดหาโดยท่าน ทางไปรษณีย์ที่ดำเนินการโดยท่าน การบริการการขนส่งของท่านเอง
				<ol>
				<li>ท่านต้องเตรียมและขนส่งสินค้าภายใต้สัญญาผู้ซื้อไปยังที่อยู่ที่ระบุไว้ในคำสั่งซื้อที่เกี่ยวข้องภายในระยะเวลาที่กำหนดไว้ หากท่านไม่สามารถปฏิบัติตามกำหนดเวลาที่ระบุไว้ เยลโลไทร์อาจแก้ไขกำหนดเวลาดังกล่าว และ/หรือยกเลิกคำสั่งซื้อนั้น
				</li>
				<li>ท่านจะต้องอัพเดทสถานการณ์ขนส่งบนหน้าร้านค้าภายในกรอบระยะเวลาที่กำหนดไว้ในนโยบาย
				</li>
				<li>ท่านต้องหยุดหรือยกเลิกคำสั่งซื้อใดๆ หากมีการแจ้งให้ดำเนินการจากเยลโลไทร์
				</li>
				<li>ท่านจะต้องดำเนินการใดๆ เพื่อให้แน่ใจได้ว่าเยลโลไทร์จะได้รับข้อมูลการติดตามสถานะการขนส่งของคำสั่งซื้อที่เป็นปัจจุบันตลอดเวลา
				</li>
				<li>ท่านต้องรับผิดชอบและรับความเสี่ยงรวมถึงความรับผิดทั้งหมดสำหรับการคัดแยก ขาย บรรจุ ทำฉลาก ดูคุณภาพสินค้าและรับประกันสินค้า (หากมี) สำหรับสินค้าทั้งหมดที่ขนส่งโดยรูปแบบการขนส่งโดยผู้ขาย และท่านต้องรับผิดชอบซึ่งข้อเรียกร้องทั้งหมดที่เกี่ยวข้องกับสินค้าดังกล่าว
				</li>
				<li>ท่านจะต้องไม่ร้องขอเอกสารใดๆ จากผู้ซื้อ (เว้นแต่เพื่อยืนยันการรับสินค้าจากขนส่ง) ระหว่างขั้นตอนการขนส่ง
				</li>
				<li>กรรมสิทธิ์และความเสี่ยงของการสูญหายของสินค้ายังคงอยู่ที่ท่านตลอดเวลาและเยลโลไทร์ไม่มีความรับผิดใดๆ เกี่ยวกับสินค้า รวมไปถึงการขนส่ง การเก็บรักษา การขนส่งล่าช้า ความเสียหายหรือสูญหายระหว่างการขนส่งโดยผู้ขาย
				</li>
				</ol>
				</li>
				</ol>
				</li>
				<li>
				<strong>การยกเลิกสินค้า กรณีส่งมอบสินค้าไม่สำเร็จ</strong>
				<ol>
				<li><strong>การยกเลิกสินค้า </strong>กรณีการจัดส่งแล้ว ค่าใช้จ่ายสำหรับการจัดส่งสินค้าคืนนั้นผู้ซื้อจะเป็นผู้รับผิดชอบทั้งหมด
				</li>
				<li><strong>กรณีของการจัดส่งสินค้าล่าช้ากว่าที่กำหนด </strong>เยลโลไทร์สามารถร้องขอให้ท่านรับผิดชอบซึ่งค่าใช้จ่ายที่เกี่ยวข้องกับการยกเลิกสินค้า
				</li>
				<li><strong>กรณีของการติดตั้งไม่สำเร็จ </strong>หากเกิดจากผู้ขายเยลโลไทร์สามารถร้องขอให้ท่านรับผิดชอบซึ่งค่าใช้จ่ายที่เกี่ยวข้องกับการยกเลิกสินค้า และ/หรือการเปลี่ยนสินค้า
				</li>
				<li><strong>เยลโลไทร์ไม่มีส่วนรับผิดชอบ </strong>เยลโลไทร์ไม่ต้องรับผิดชอบในความเสี่ยงหรือความผิดใดๆ เกี่ยวกับข้อเรียกร้อง การร้องขอ ความรับผิด ค่าใช้จ่าย การสูญหาย ต้นทุนหรือความเสียหายที่เกี่ยวข้องกับการจัดส่งไม่สำเร็จใดๆ และการคืนสินค้า (รวมไปถึงการถูกเตือนให้เรียกคืน) และจะเรียกค่าใช้จ่ายทั้งหมดที่เกิดขึ้นจากการดังกล่าวจากท่าน
				</li>
				</ol>
				</li>
				<li>
				<strong>สิทธิของเยลโลไทร์</strong>
				<ol>
				<li><strong>หากสินค้าหรือพฤติกรรมของท่านบนแพลตฟอร์มนั้นไม่เป็นไปตามข้อกำหนด</strong> นโยบาย กฎหมายที่เกี่ยวข้องหรือไม่ว่าด้วยสาเหตุใดที่สมควร ไม่ว่าในเวลาใด เยลโลไทร์สามารถ
				<ol>
				<li>ปฏิเสธที่จะแสดงรายการสินค้า หรือยกเลิกแสดงรายการสินค้าใดๆ หรือทั้งหมดของท่าน
				</li>
				<li>ยกเลิกหรือเลื่อนการโฆษณา การตั้งราคาหรือผลประโยชน์ด้านการเข้าชม
				</li>
				<li>หักเงิน (หรือร้องขอให้ผู้ให้บริการที่เยลโลไทร์กำหนดทำการหักเงินไว้) จากบัญชีผู้ขายของท่าน  และจำนวนดังกล่าวสามารถนำไปใช้สำหรับการคืนเงินแก่ผู้ซื้อที่มีสิทธิ การใช้เงินคืนสำหรับส่วนที่ต้องคืนหรือการลดราคาโดยเยลโลไทร์แก่ท่าน และหักเพื่อเป็นค่าใช้จ่าย ค่าธรรมเนียม โทษหรือค่าปรับใดๆ ที่เรียกเก็บโดยหน่วยงานที่มีอำนาจ ทั้งนี้ก่อนจะทำการหักเงิน เยลโลไทร์ จะแจ้งเหตุผล และความจำเป็นที่สมเหตุสมผลแก่ร้านค้าก่อนทุกครั้ง
				</li>
				<li>อนุญาตให้ผู้ซื้อสามารถยกเลิกคำสั่งซื้อเนื่องมาจากแพลตฟอร์มหรือสินค้านั้นไม่สามารถเข้าถึงได้หลังจากที่ได้มีการเริ่มดำเนินธุรกรรมไปแล้ว
				</li>
				<li>เรียกให้ท่านต้องชำระค่าดำเนินการ ค่าปรับ/ค่าธรรมเนียมจากการผิดสัญญาและค่าใช้จ่าย ค่าธรรมเนียม โทษ หรือค่าปรับใดที่บังคับโดยหน่วยงานที่มีอำนาจ
				</li>
				</ol>
				</li>
				<li><strong>การยกเลิกบัญชีผู้ขาย เยลโลไทร์สามารถยกเลิกบัญชีผู้ขายของท่านได้ทันทีและระงับการจ่ายใดๆ ที่ถึงกำหนดชำระแก่</strong>ท่านทั้งหมด หาก
				<ol>
				<li>ท่านละเมิดหน้าที่ใดๆ ภายใต้ข้อกำหนดนี้ นโยบาย หรือกฎหมายที่เกี่ยวข้องเกี่ยวกับสิทธิในทรัพย์สินทางปัญญา
				</li>
				<li>ท่านขายสินค้าปลอม สินค้าที่ไม่มีคุณภาพ ส่งมอบสินค้าไม่มีคุณภาพ ส่งมอบสินค้าล่าช้า หรือการบริการติดตั้งสินค้าที่ไม่ได้มาตรฐาน
				</li>
				<li>ท่านใช้แพลตฟอร์ม การบริการและหน้าร้านค้าในลักษณะที่เป็นการฉ้อฉล
				</li>
				</ol>
				</li>
				<li><strong>เป้าหมายในการกำกับดูแล </strong>เพื่อเป้าหมายในการป้องกันการฉ้อฉล การปฏิบัติตามกฎหมายที่เกี่ยวข้องหรือข้อกำหนดนี้ หรือเหตุผลทางการค้าที่เหมาะสมอื่นใด เยลโลไทร์สามารถกำหนดมูลค่าคำสั่งซื้อหรือกำจัดธุรกรรมบนบัญชีผู้ขายของท่าน และ/หรือรายการสินค้าของท่าน
				</li>
				<li><strong>ผู้ให้บริการซึ่งเป็นบุคคลภายนอก </strong>เยลโลไทร์สามารถดำเนินการร่วมกับ และ/หรือใช้บริการของผู้ให้บริการที่เยลโลไทร์กำหนดหรือผู้ให้บริการซึ่งเป็นบุคคลภายนอกในส่วนที่เกี่ยวข้องกับการบริการได้
				</li>
				<li><strong>การเปลี่ยนแปลงคำสั่งซื้อ หรือ การดำเนินการเกี่ยวกับคำสั่งซื้อ</strong> เยลโลไทร์สามารถปฏิเสธหรือระงับคำสั่งซื้อ หรือการชำระค่าสินค้าไม่ว่าในรูปแบบใด เพื่อตรวจสอบ หากทางเยลโลไทร์พบว่า ผู้ซื้อหรือผู้ขาย ละเมิดข้อตกลงหรือไม่ทำตามเงื่อนไขการซื้อ/ขายสินค้า ในสัญญานี้
				</li>
				<li><strong>ความเสี่ยงเกี่ยวกับการฉ้อโกงบัตรเครดิต โดยระหว่างเยลโลไทร์กับท่านนั้น ท่านจะไม่ถูกร้องขอให้เป็นผู้รับความเสี่ยงต่อการฉ้อโกงด้วยบัตรเครดิต </strong>(การฉ้อโกงจากการซื้อซึ่งเกิดขึ้นการขโมยหรือการใช้ข้อมูลบัตรเครดิตของผู้ซื้อโดยไม่ได้รับอนุญาต) ที่เกิดขึ้นเกี่ยวข้องกับคำสั่งซื้อเว้นแต่เกี่ยวข้องกับการฉ้อโกงใดๆ ที่เกี่ยวโยงถึงท่านไม่ว่าโดยตรงหรือโดยอ้อม โดยท่านจะต้องรับความเสี่ยงทั้งหมดของการฉ้อโกงหรือความเสียหาย รวมไปถึงความเสียหายที่เกิดขึ้นแก่เยลโลไทร์
				</li>
				<li><strong>เยลโลไทร์สามารถกำหนดให้สินค้า </strong>หรือท่านอยู่ภายใต้กิจกรรมทางการค้า โดยใช้กลไกในการให้คะแนน หรืออนุญาตให้ผู้ซื้อสามารถให้คะแนนหรือให้ข้อคิดเห็นซึ่งสินค้า และ/หรือการปฏิบัติการในฐานะผู้ขาย และเยลโลไทร์อาจดำเนินการให้คะแนนและการให้ข้อคิดเห็นดังกล่าวประกาศเป็นสาธารณะได้ หากท่านเชื่อว่าการประเมิน หรือการให้คะแนนโดยผู้ซื้อนั้นๆ ไม่ถูกต้อง สามารถติดต่อกับทางเยลโลไทร์เพื่อชี้แจง หลังจากนั้นทางเว็บจะพิจารณานำข้อมูลการประเมินนั้นๆ ออกจากระบบ
				</li>
				</ol>
				</li>
				<li>
				<strong>การรับรอง รับประกันและหน้าที่ของผู้ขาย</strong>
				<ol>
				<li><strong>หน้าที่ทั่วไป</strong> โดยการใช้บริการและใช้เครื่องมือที่เราหรือบริษัทในเครือของเยลโลไทร์ไว้ให้ท่านมีหน้าที่รับรองและรับประกันว่า
				<ol>
				<li>ท่านจะปฏิบัติตามกฎหมายและกฎเกณฑ์ที่เกี่ยวข้องทั้งหมด รวมไปถึงกฎหมายภาษีทั้งหมดที่เกี่ยวข้องกับกิจกรรมของท่าน โดยท่านเป็นผู้รับผิดชอบและชำระภาษีและค่าใช้จ่ายอื่นที่เกิดขึ้นเกี่ยวเนื่องกับข้อกำหนดนี้และสัญญาผู้ซื้อ และมีไว้ซึ่งสิทธิ ใบอนุญาต การอนุญาตหรือการอนุมัติใดที่จำเป็นทั้งหมดสำหรับการเสนอ โฆษณาและการขายสินค้าบนหรือผ่านเพลตฟอร์ม
				</li>
				<li>ท่านต้องปฏิบัติตามข้อกำหนดนี้ นโยบายและข้อกำหนดอื่นใดเพิ่มเติมรวมไปถึงข้อตกลงอนุญาตให้ใช้สิทธิของผู้ใช้งาน
				</li>
				<li>ท่านต้องรวมข้อมูลและเอกสารประกอบทั้งหมดที่จำเป็นภายใต้กฎหมายที่เกี่ยวข้อง และรับรองว่าข้อมูลใดๆ ที่ให้ไว้ภายใต้ข้อกำหนดนี้ถูกต้อง เป็นปัจจุบันและสมบูรณ์และไม่ทำให้หลงผิด
				</li>
				<li>ท่านจะต้องจัดการสินค้าตามคำสั่งซื้อสินค้าทั้งหมดตามจำนวน และราคาที่ระบุแก่ผู้ซื้อ และจะต้องรับผิดชอบซึ่งข้อผิดพลาดใดๆ ในรายการราคาที่ได้แสดงไว้
				</li>
				<li>ท่านจะต้องไม่ละเมิดซึ่งสิทธิในทรัพย์สินทางปัญญาใดๆ
				</li>
				<li>ท่านจะไม่แจ้ง แสดงหรือเปิดเผยเนื้อหาสิ่งใดๆ ที่เป็นการละเมิดนโยบายของเรา
				</li>
				<li>ท่านต้องไม่ใช้หรือไม่อนุญาตให้บุคคลใดใช้แพลตฟอร์ม การบริการและหน้าร้านค้าโดยผิดกฎหมาย ในลักษณะที่ไม่ถูกต้อง ทำให้หลงผิด ผิดพลาด ฉ้อโกง ทำให้เสียชื่อเสียง หมิ่นประมาททางการค้าหรือการอื่นใดที่เป็นการใช้ในวิธีการที่ไม่เหมาะสม
				</li>
				<li>ท่านต้องไม่เปิดร้านค้าหลายร้าน หรือก่อให้เกิดการฉ้อฉล การทำซ้ำหรือการอื่นใดที่ทำให้เกิดการดูสินค้า การแสดงผล การตั้งคำถาม หรือ การโต้ตอบอื่นใดโดยทุจริตไม่ว่าผ่านการใช้แอปพลิเคชันอัตโนมัติหรือวิธีการอื่นใด
				</li>
				<li>ท่านจะต้องไม่ดำเนินกิจกรรมเช่นการพนัน การชิงโชค การสุ่มและฉลาก (ล็อตเตอรี่) หรือเข้าร่วมในกิจกรรมใดซึ่งเกี่ยวข้องกับสิ่งที่เรียกว่าธุรกิจแบบพีรามิดหรือแบบแชร์ลูกโซ่ หรือกิจกรรมอื่นใดที่ผิดกฏหมาย ผิดศีลธรรมหรือต่อต้านสังคม
				</li>
				<li>ท่านจะต้องไม่เข้าถึงเนื้อหาหรือข้อมูลใดที่เกี่ยวข้องกับคู่สัญญาอื่นนอกจากตัวท่านเอง ไม่ส่งต่อการเจรจาที่ไม่ได้ถูกร้องขอ ไม่แทรกแซงการดำเนินการอย่างเหมาะสมของแพลตฟอร์มหรือหน้าร้านค้า ไม่ส่งต่อไวรัส ม้าโทรจัน หรือรหัสที่เป็นอันตรายใดๆ หรือพยายามที่จะเลี่ยงซึ่งกลไกใดที่ใช้ในการตรวจสอบหรือป้องกันกิจกรรมดังกล่าว
				</li>
				<li>ท่านต้องไม่เจตนาทำการเปิดเผยเยลโลไทร์ และ/หรือบริษัทในเครือของเยลโลไทร์และพนักงาน ลูกจ้าง กรรมการ คู่สัญญา หุ้นส่วน ตัวแทน ผู้รับจ้างช่วง ผู้แทน อันก่อให้เกิดความเสี่ยงที่ไม่เหมาะสมหรือเข้าผูกพันตนซึ่งกิจกรรมที่เยลโลไทร์เห็นว่าอาจเป็นอันตรายแก่การปฏิบัติการ ชื่อเสียงหรือกู้ดวิลล์ของเยลโลไทร์และบริษัทในเครือของเยลโลไทร์
				</li>
				</ol>
				</li>
				<li><strong>หน้าที่เกี่ยวข้องกับสินค้า </strong>ท่านตกลง รับรองและรับประกันว่า
				<ol>
				<li>สินค้านั้นมีคุณภาพ ได้มาตรฐาน ปราศจากข้อบกพร่องและเป็นไปตามรายละเอียดที่ระบุไว้
				</li>
				<li>สินค้าและข้อเสนอสินค้าที่ขายนั้นไม่ต้องห้ามและเป็นไปตามกฎหมายที่เกี่ยวข้อง และเป็นไปตามนโยบายของเยลโลไทร์
				</li>
				<li>ท่านต้องส่งเอกสารที่จำเป็นตามกฎหมายทั้งหมดที่เกี่ยวข้องกับสินค้า (รวมถึงเอกสารรับประกัน ข้อมูลรับประกันและใบแจ้งหนี้ราคาสินค้า) และอัพเดทสิ่งดังกล่าวให้เป็นข้อมูลปัจจุบันตามกฎหมาย และท่านจะต้องส่งซึ่งเอกสารดังกล่าว แก่เยลโลไทร์ และ/หรือผู้ซื้อเมื่อมีการร้องขอ
				</li>
				<li>ท่านไม่มีภาระผูกพันใดๆ ในสินค้าและในอุปกรณ์ใดที่เป็นส่วนหนึ่งของสินค้า และสินค้าทั้งหมดที่ขายปราศจากสิทธิการครอบครอง ยึดหน่วงโดยผู้อื่น ภาระผูกพัน หรือการค้าประกันอื่นใด
				</li>
				<li>ท่านต้องส่งเอกสารหรือข้อมูลใดๆ แก่เยลโลไทร์เพื่อแสดงถึงสิทธิในการขายสินค้าของท่าน รวมไปถึงสิทธิ ใบอนุญาต และ/หรือการอนุญาตให้ขายซึ่งสินค้าดังกล่าว เอกสารอื่นใดที่ให้สิทธิแก่ท่านในการกระจายสินค้า และหากมีความจำเป็นต้องให้สำเนาใบแจ้งราคาสินค้าที่รับรองหรือหลักฐานอื่นใดโดยท่านต้องเป็นผู้รับผิดชอบซึ่งค่าใช้จ่ายสำหรับการดังกล่าว
				</li>
				</ol>
				</li>
				<li><strong>หน้าที่เกี่ยวข้องกับเนื้อหาของผู้ขาย </strong>ท่านรับทราบ ยอมรับ ให้การรับรองและรับประกันว่า
				<ol>
				<li>ท่านเป็นเจ้าของหรือมีสิทธิที่ถูกต้องตามกฎหมายในการใช้ทรัพย์สินทางปัญญา ในส่วนที่เกี่ยวกับสินค้าและเนื้อหาของผู้ขาย
				</li>
				<li>เนื้อหาของผู้ขายนั้นไม่ต้องห้าม และเป็นไปตามกฎหมายที่เกี่ยวข้อง และเป็นไปตานโยบายของเยลโลไทร์ ทั้งนี้ ท่านตกลงอนุญาตให้เยลโลไทร์สามารถใช้ รวบรวม และ เปิดเผยข้อมูลเกี่ยวกับการขาย สินค้าที่ของท่านให้กับคู่ค้า หรือซัพพลายเออร์ของเยลโลไทร์ เพื่อนำไปใช้ในการประเมินและวางกลยุทธ์ทางการขายและการตลาดเพื่อวัตถุประสงค์ในการดำเนินงานของแพลตฟอร์มให้มีประสิทธิภาพและทันสมัยอยู่เสมอ
				</li>
				<li>ท่านจะต้องไม่ใช้สิทธิในทรัพย์สินทางปัญญาใดๆ ที่เรา และ/หรือบริษัทในเครือของเยลโลไทร์เป็นเจ้าของ โดยไม่ได้รับอนุญาตเป็นลายลักษณ์อักษรจากเยลโลไทร์ล่วงหน้า
				</li>
				<li>ท่านจะต้องนำเสนอเนื้อหาของผู้ขายที่ถูกต้อง และจะต้องไม่มีสิ่งใดที่เกี่ยวกับเพศ การทำลายชื่อเสียงหรือลามก หรือสิ่งใดที่เป็นวัตถุที่เกี่ยวข้องกับการตลาดของท่านหรือบุคคลภายนอก
				</li>
				<li>ท่านจะไม่แสดง URL (“URL Marks”) ใดๆ เพื่อใช้งานบนแฟลตฟอร์ม หรือร้องขอให้มีการใช้URL Marks ใด บนแพลตฟอร์ม
				</li>
				<li>ท่านให้สิทธิและการอนุญาตแก่เยลโลไทร์หรือบริษัทในเครือของเยลโลไทร์ในการใช้ทำซ้ำ แสดง เปลี่ยนแปลง และปรับปรุงซึ่งเนื้อหาของผู้ขายใดๆ และทั้งหมดตามที่ผู้ขายได้ให้ไว้โดยไม่มีค่าใช้จ่าย ไม่ผูกขาดและสามารถใช้ได้ทั่วโลก โดยเป็นไปตามคำสั่ง และ/หรือข้อกำหนดของผู้ขายอย่างเคร่งครัด เพื่อวัตถุประสงค์ในการดำเนินงานของแพลตฟอร์มหรือการให้บริการภายใต้สัญญาฉบับนี้
				</li>
				<li>เยลโลไทร์สามารถกำหนดการใช้และการวางเนื้อหาของผู้ขายและโครงสร้าง การแสดง รูปแบบ ความสามารถในการใช้งานและลักษณะอื่นทั้งหมดของแพลตฟอร์ม การบริการและกิจกรรมทางการค้า (หากมี)
				</li>
				<li>เยลโลไทร์อาจใช้ระบบที่ประเมิน หรืออนุญาตให้ผู้ซื้อประเมินหรือแสดงข้อคิดเห็น ต่อสินค้าของท่าน และ/หรือการดำเนินการของท่านในฐานะผู้ขาย และเราสามารถเผยแพร่การประเมินและการแสดงข้อคิดเห็นดังกล่าวต่อสาธารณะ เยลโลไทร์ไม่ต้องรับผิดชอบซึ่งข้อคิดเห็นหรือการประเมินที่ทำโดยระบบหรือโดยผู้ซื้อในส่วนที่เกี่ยวข้องกับสินค้าใดๆ และ/หรือการดำเนินการของท่าน หากท่านเชื่อว่าการประเมิน หรือการให้คะแนนโดยผู้ซื้อนั้นๆ ไม่ถูกต้อง สามารถติดต่อกับทางเยลโลไทร์เพื่อชี้แจง หลังจากนั้นทางเว็บจะพิจารณานำข้อมูลการประเมินนั้นๆ ออกจากระบบ
				</li>
				<li>ข้อกำหนดนี้ไม่ได้มอบซึ่งกรรมสิทธิ์หรือสิทธิใดๆ ใบอนุญาตหรือสิทธิในทรัพย์สินทางปัญญาอื่นใด ของทรัพย์สินที่จับต้องได้และจับต้องไม่ได้ รวมไปถึงซอฟท์แวร์ และข้อมูล ท่านได้มอบ สละหรือโอน (และทำให้การโอนมีผล) ซึ่งกรรมสิทธิ์ทั้งหมดแต่เพียงผู้เดียวให้แก่เยลโลไทร์หรือบุคคลอื่นใดที่กำหนดโดยเยลโลไทร์ โดยไม่มีค่าใช้จ่ายหรือในค่าธรรมเนียมขั้นต่ำและ ไม่มีสิ่งใดที่ระบุในข้อกำหนดนี้ที่จะจำกัดหรือห้ามสิทธิของเราหรือบุคคลภายนอกในการแสดงการเรียกร้องซึ่งการฝ่าฝืนซึ่งสิทธิทางทรัพย์สินทางปัญญาใดๆ จากท่าน
				</li>
				</ol>
				</li>
				<li><strong>คำรับรองและการรับประกันเพิ่มเติม </strong>การใช้บริการ แพลตฟอร์มหรือหน้าร้านค้านั้นจำกัดเพียงสำหรับคู่สัญญาที่สามารถเข้าถึงและทำสัญญาภายใต้กฎหมายที่เกี่ยวข้อง ท่านรับรองและรับประกันว่า
				<ol>
				<li>ท่านจะต้องเป็นนิติบุคคลที่จัดตั้งและจดทะเบียนโดยชอบด้วยกฎหมาย และตั้งอยู่โดยถูกต้องและมีความน่าเชื่อถือภายใต้กฎหมายของประเทศไทย
				</li>
				<li>ท่านต้องมีอำนาจความสามารถ และได้รับมอบอำนาจในการดำเนินการอันสมบูรณ์ที่จะเข้าทำและปฏิบัติตามหน้าที่ของท่านภายใต้ข้อกำหนดนี้
				</li>
				<li>ข้อมูลใดๆ ที่มีให้หรือสร้างโดยท่านหรือบริษัทในเครือของท่านจะต้องถูกต้องและสมบูรณ์ตลอดเวลา
				</li>
				<li>ท่านและบุคคลหรือหน่วยงานใดๆ ที่มีผลประโยชน์ทางการเงินในธุรกิจของท่านหรือบุคคลหรือหน่วยงานใดๆ ที่ทำการในนามของท่านต้องไม่มีส่วนเกี่ยวข้องกับลูกจ้างคนใดของเยลโลไทร์ซึ่งอาจเป็นผลให้ หรือก่อให้เกิดซึ่งการขัดกันในผลประโยชน์
				</li>
				<li>ท่านตกลงและรับประกันว่าคำรับรอง การรับประกันและหน้าที่ภายใต้ข้อกำหนดนี้ที่ต้องยังคงสมบูรณ์ เป็นความจริงและถูกต้องตลอดเวลา ในกรณีที่การดังกล่าวไม่สมบูรณ์ ไม่เป็นความจริงหรือไม่ถูกต้อง ท่านจะต้องแจ้งต่อเยลโลไทร์ซึ่งการดังกล่าวโดยทันที และแก้ไขเหตุการณ์ดังกล่าวจนเป็นที่พอใจแก่เยลโลไทร์
				</li>
				</ol>
				</li>
				</ol>
				</li>
				<li>
				<strong>ข้อมูลที่เป็นความลับ</strong>
				<ol>
				<li><strong>ข้อห้ามในการเปิดเผย </strong>ผู้รับซึ่งข้อมูลที่เป็นความลับใดๆ จะต้องไม่เปิดเผยข้อมูลที่เป็นความลับดังกล่าว เว้นแต่ต่อบริษัทในเครือ พนักงาน ซัพพลายเออร์ คู่ค้าที่เกี่ยวข้อง และ/หรือตัวแทนผู้ที่มีความจำเป็นที่จะต้องทราบถึงข้อมูลดังกล่าว และผู้ซึ่งได้ตกลงเป็นลายลักษณ์อักษรว่าจะเก็บข้อมูลดังกล่าวไว้เป็นความลับ ผู้รับข้อมูลไปจะต้องรับรองว่าบุคคล และหน่วยงานดังกล่าวจะใช้ข้อมูลที่เป็นความลับเพียงเพื่อที่จะใช้สิทธิและทำตามหน้าที่ให้สมบูรณ์ภายใต้ข้อกำหนด ผู้รับข้อมูลอาจเปิดเผยข้อมูลส่วนบุคคลดังกล่าวเมื่อต้องดำเนินการตามกฎหมาย
				</li>
				<li><strong>การมีผลบังคับต่อไปซึ่งหน้าที่</strong> สิทธิและหน้าที่ของคู่สัญญาภายใต้ข้อกำหนดข้อนี้จะมีผลบังคับอยู่แม้ข้อกำหนดนี้เลิกไป
				</li>
				</ol>
				</li>
				<li>
				<strong>ข้อมูลส่วนบุคคลและข้อมูลของผู้ซื้อ</strong>
				<ol>
				<li><strong>การใช้และการประมวลข้อมูลส่วนบุคคล </strong>ท่านตกลง รับรองและรับประกันว่าท่านจะใช้และประมวลข้อมูลส่วนบุคคล (โดยเฉพาะ ข้อมูลส่วนบุคคลของผู้ซื้อ)
				<ol>
				<li>เพียงสำหรับวัตถุประสงค์ในการปฏิบัติตามข้อกำหนดนี้หรือสัญญาผู้ซื้อและไม่เปิดเผยข้อมูลดังกล่าวต่อบุคคลภายนอก
				</li>
				<li>เป็นไปตามข้อกำหนดภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคลและนโยบายที่เกี่ยวข้อง
				</li>
				<li>ดำเนินการให้ลักษณะที่สามารถมั่นใจได้ว่าเยลโลไทร์จะยังดำเนินการเป็นไปตามข้อกำหนดภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคลที่เกี่ยวข้อง
				</li>
				<li>ท่านจะไม่ขาย โอน อนุญาต เผยแพร่ให้เช่าหรือการอื่นใดที่เป็นไปในทางหาประโยชน์ทางการค้าซึ่งข้อมูลใดๆ หรือใช้ซึ่งข้อมูลดังกล่าวในลักษณะเพื่อผลประโยชน์ส่วนบุคคลของท่านเองหรือทำการขุดข้อมูล รวบรวมข้อมูลหรือสกัดข้อมูลเพื่อวัตถุประสงค์ในการทำสถิติหรือวิเคราะห์ทางการค้าหรือการอื่นใด
				</li>
				<li>ท่านรับประกันว่าท่านได้ใช้มาตรการการรักษาความปลอดภัยที่เพียงพอในการทำให้แน่ใจว่าข้อมูลส่วนบุคคลนั้นถูกเก็บและรักษาไว้ตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลที่เกี่ยวข้องและท่านตกลงที่จะถูกบังคับภายใต้การตรวจสอบที่จำเป็นที่ดำเนินการโดยเยลโลไทร์เพื่อที่จะแน่ใจว่าท่านได้ปฏิบัติตามคำรับรองข้างต้นและจะแจ้งต่อเยลโลไทร์โดยทันทีหากมีเหตุการณ์ใดๆ เกี่ยวข้องกับข้อมูลส่วนบุคคลหรือรับทราบมาซึ่งเหตุการณ์ดังกล่าว
				</li>
				</ol>
				</li>
				<li><strong>สิทธิในข้อมูล </strong>เยลโลไทร์เป็นเจ้าของซึ่งข้อมูลทั้งหมดเกี่ยวกับผู้ซื้อ คำสั่งซื้อและอุปทานของการบริการรวมไปถึงการชำระเงิน ค่าธรรมเนียม ค่าใช้จ่าย การคืนเงิน การยกเลิก ค่าปรับ การปรับเปลี่ยน เป็นต้น และเยลโลไทร์ไม่ต้องรับผิดในการชำระซึ่งค่าสิทธิหรือค่าธรรมเนียมใดๆ แก่ท่านในส่วนที่เกี่ยวข้องกับการใช้ซึ่งข้อมูลใดๆ ดังกล่าว
				</li>
				</ol>
				</li>
				<li>
				<strong>ความรับผิด – ข้อจำกัดความรับผิด และการชดใช้ค่าสินไหมทดแทน</strong>
				<ol>
				<li><strong>การบริการและการบริการเสริมจะมอบให้แก่ท่าน </strong>ที่มีให้หรือผ่านแพลตฟอร์ม หน้าร้านค้า การบริการและการบริการเสริมอาจมีข้อผิดพลาด เยลโลไทร์และบริษัทในเครือของเยลโลไทร์จะไม่มีความรับผิดอย่างชัดแจ้งซึ่งข้อผิดพลาดใดๆ ทั้งหมดเท่าที่กฎหมายที่เกี่ยวข้องจะอนุญาต
				</li>
				<li><strong>บริษัทฯ ไม่มีความรับผิดในกรณีในการไม่สามารถให้บริการได้ </strong>ท่านรับทราบว่าการให้บริการ แพลตฟอร์ม หน้าร้านค้านั้นขึ้นอยู่กับ
				<ol>
				<li>การมีอยู่ของทรัพยากรภายใต้การควบคุมของเยลโลไทร์และการมีอยู่ของโครงสร้างเครือข่ายที่เหมาะสม
				</li>
				<li>ความสามารถด้านภูมิศาสตร์และทางด้านเทคนิคของเครือข่ายการคมนาคมและระบบการขนส่งอื่นๆ
				</li>
				<li>เวลาสำหรับการจัดการซึ่งทางเยลโลไทร์อาจร้องขอให้มีสำหรับการให้บริการ และ/หรือการให้บริการเสริม
				</li>
				<li>ท่านที่สามารถปฏิบัติตามข้อกำหนดทางเทคนิคในการเข้าถึงหน้าร้านค้าเป็นครั้งคราว
				</li>
				</ol>
				</li>
				<li><strong>เยลโลไทร์ไม่ได้ให้คำรับรองหรือการรับประกันไม่ว่าชนิดใด </strong>ไม่ว่าโดยชัดแจ้งหรือโดยพฤตินัยรวมไปถึง
				<ol>
				<li>การรับประกันโดยนัยการของรับประกันสินค้า ความเหมาะสมตามวัตถุประสงค์ สิทธิ และการอันที่ไม่เป็นการละเมิด
				</li>
				<li>แพลตฟอร์ม หน้าร้านค้า การบริการหรือการให้บริการเสริมนั้นเป็นไปตามความต้องการของท่าน และจะมีอยู่ สามารถเข้าถึงได้ ไม่ถูกรบกวน มีอยู่ในเวลาที่เหมาะสม ปลอดภัย และดำเนินการได้โดยไม่มีข้อผิดพลาด
				</li>
				<li>ข้อมูล เนื้อหา วัตถุหรือสินค้าที่มีอยู่บนแพลตฟอร์ม หรือหน้าร้านค้าจะถูกนำเสนอโดยเยลโลไทร์ หรือว่าเยลโลไทร์หรือผู้ซื้อจะดำเนินการตามที่ตกลง
				</li>
				<li>การรับประกันโดยนัยใดๆ ที่เกิดขึ้นจากแนวทางการดำเนินการหรือการทำการซื้อขาย
				</li>
				<li>หน้าที่ ความรับผิด สิทธิ ข้อเรียกร้องหรือการเยียวยาการละเมิด เว้นแต่เป็นการกระทำที่เกิดขึ้นจากการฉ้อฉล ละเมิดอย่างร้ายแรงหรือการกระทำผิดโดยเจตนาโดยเยลโลไทร์เอง
				</li>
				</ol>
				</li>
				<li><strong>การแก้ไขเอกสารหรือเนื้อหา </strong>ข้อผิดพลาดในการพิมพ์หรือข้อผิดพลาดอื่นใดหรือความไม่สมบูรณ์ไม่ว่าในรูปแบบใด ในการตอบรับ ในใบแจ้งหนี้ในเนื้อหาของผู้ขายหรือเอกสารอื่นใดในส่วนของเยลโลไทร์ จะถูกแก้ไขให้ถูกต้องโดยเยลโลไทร์ไม่ต้องรับผิดใดๆ
				</li>
				<li><strong>การชดเชยค่าเสียหาย </strong>ท่านจะต้องปกป้อง ชดเชยค่าเสียหายและยกเว้นความรับผิดให้แก่เยลโลไทร์ บริษัทในเครือและเจ้าพนักงาน ลูกจ้าง กรรมการ ผู้รับเหมา หุ้นส่วน ตัวแทน ผู้รับจ้างช่วง ผู้แทน ของเยลโลไทร์ ตามที่เยลโลไทร์เลือกว่าจะให้คุ้มครองเยลโลไทร์ จากข้อเรียกร้องใดๆ และทั้งหมดที่เกิดขึ้นหรือเกี่ยวข้องกับ
				<ol>
				<li>การผิดข้อกำหนด คำรับรอง การรับประกันหรือหน้าที่ใดๆ ตามที่กำหนดไว้ในข้อกำหนดนี้ หรือสัญญาผู้ซื้อไม่ว่าโดยแท้จริงหรือถูกกล่าวหา
				</li>
				<li>ข้อมูลที่ไม่ถูกต้อง ทำให้หลงผิดหรือผิดพลาดที่ให้แก่เยลโลไทร์หรือบุคคลภายนอกใดๆ ในส่วนที่เกี่ยวข้องกับการบริการและบริการเสริม
				</li>
				<li>กรณีใดๆ ที่ท่านไม่ปฏิบัติตามซึ่งกฎหมายที่เกี่ยวข้องหรือนโยบายใดๆ รวมไปถึงความเสียหายใดๆ ที่เกี่ยวข้องกับการขนส่งสินค้าต้องห้ามหรือสินค้าควบคุมซึ่งเกิดขึ้นต่อเยลโลไทร์หรือผู้รับจ้างช่วงของเยลโลไทร์
				</li>
				<li>ค่าใช้จ่ายใดๆ ในการปฏิบัติตามหลักเกณฑ์หรือความรับผิดทางภาษีที่เกิดกับเยลโลไทร์หรือบริษัทในเครือของเยลโลไทร์ ในส่วนที่เกี่ยวข้องกับกิจกรรมของท่านที่มาจากการไม่ปฏิบัติตามกฎหมายภาษีที่เกี่ยวข้องหรือในกรณีที่เราหรือบริษัทในเครือเยลโลไทร์ถูกถือให้เป็นตัวแทนภาษีของท่าน
				</li>
				<li>เว็บไซต์หรือช่องทางการขายอื่นของท่าน สินค้า หรือเนื้อหาของผู้ขาย การโฆษณา ข้อเสนอ การขายหรือการคืนสินค้า การละเมิดซึ่งสิทธิในทรัพย์สินทางปัญญาหรือถูกกล่าวหาว่าละเมิดซึ่งสิทธิในทรัพย์สินทางปัญญาของสินค้าหรือเนื้อหาของผู้ขาย หรือภาษีของผู้ขาย หรือการเก็บ การจ่ายหรือการไม่สามารถเรียกเก็บหรือชำระภาษีผู้ขายได้ โดยหากไม่ว่าในเวลาใดเยลโลไทร์มีเหตุที่ทำให้คาดหมายได้ว่าข้อเรียกร้องให้ชดใช้ความเสียหายอาจมีผลกระทบในแง่ลบแก่เยลโลไทร์ เยลโลไทร์สามารถเข้าควบคุมในการต่อสู้คดีโดยให้ท่านเป็นผู้รับผิดชอบด้านค่าใช้จ่าย ท่านไม่สามารถตกลงยินยอมต่อการตัดสินหรือเข้าตกลงประนีประนอมยอมความซึ่งข้อเรียกร้องใดที่มีผลกระทบต่อเยลโลไทร์โดยไม่ได้รับความยินยอมจากเยลโลไทร์ล่วงหน้าเป็นลายลักษณ์อักษร ซึ่งความยินยอมดังกล่าวนั้นไม่สามารถถูกระงับไว้อย่างไม่สมเหตุผล
				</li>
				</ol>
				</li>
				</ol>
				</li>
				<li>
				<strong>การเลิกสัญญา</strong>
				<ol>
				<li><strong>สิทธิในการบอกเลิกสัญญาของเยลโลไทร์ </strong>เยลโลไทร์สามารถบอกเลิกข้อกำหนดนี้ได้โดยฝ่ายเดียว และโดยทันทีและสามารถห้ามท่านในการใช้บริการหากการใดๆ ดังต่อไปนี้เกิดขึ้น
				<ol>
				<li>ท่านละเมิดข้อกำหนดข้อใดในข้อกำหนดนี้ และไม่สามารถเยียวยาการดังกล่าวได้ภายใน 14 วันนับจากวันที่ได้รับแจ้ง
				</li>
				<li>ท่านละเมิดกฎหมายที่เกี่ยวข้องหรือนโยบายใดๆ เช่น มีมติให้ท่านเลิกกิจการหรือศาลที่มีเขตอำนาจมีคำสั่งเป็นสิ่งเดียวกัน หรือ มีการดำเนินการตามกระบวนการยุติธรรมเกี่ยวกับท่าน หรือมีการเข้าครอบครองเกิดภาระผูกพันหรือการขายซึ่งทรัพย์สินของท่าน
				</li>
				<li>ท่านได้จัดการหรือจัดเรียงซึ่งเจ้าหนี้ของท่านหรือยื่นต่อศาลที่มีเขตอำนาจเพื่อขอความคุ้มครองจากเจ้าหนี้ หรือ
				</li>
				<li>ท่านเลิกหรือขู่ว่าจะทำการเลิกดำเนินกิจการ
				</li>
				</ol>
				</li>
				<li><strong>สิทธิในการบอกเลิกสัญญาของผู้ขาย </strong>โดยในกรณีที่เยลโลไทร์ไม่ได้แก้ไขสิ่งดังต่อไปนี้ภายใน 14 วัน (สิบสี่วัน) นับจากวันที่ท่านได้มีหนังสือบอกกล่าวไปยังเยลโลไทร์ซึ่งการดังต่อไปนี้ที่ได้เกิดขึ้น ท่านมีสิทธิที่จะบอกเลิกข้อกำหนดนี้ได้ทันที
				<ol>
				<li>เยลโลไทร์ (หรือผู้ให้บริการที่เยลโลไทร์กำหนด) ชำระเงินล่าช้าเกิน 30 วัน (สามสิบวัน) โดยไม่มีสาเหตุ
				</li>
				<li>เยลโลไทร์ทำการคืนเงินล่าช้ามากกว่า 60 วัน (หกสิบวัน) โดยไม่มีเหตุผลที่เหมาะสม
				</li>
				<li>มีการดำเนินการตามกระบวนการยุติธรรม หรือคำสั่งทางปกครองเกี่ยวกับเยลโลไทร์ หรือการแต่งตั้งผู้พิทักษ์ทรัพย์สำหรับทรัพย์สินของเยลโลไทร์
				</li>
				<li>จัดการหรือจัดเรียงซึ่งเจ้าหนี้โดยเยลโลไทร์เองหรือยื่นต่อศาลที่มีเขตอำนาจเพื่อขอความคุ้มครองจากเจ้าหนี้
				</li>
				<li>เยลโลไทร์เลิกหรือขู่ว่าจะทำการเลิกดำเนินกิจการ
				</li>
				</ol>
				</li>
				<li><strong>การบอกเลิกสัญญาโดยการบอกกล่าวล่วงหน้า </strong>คู่สัญญาทั้งสองฝ่ายสามารถตกลงกันเพื่อเลิกข้อกำหนดนี้ได้โดยไม่มีเหตุโดยการแจ้งคู่สัญญาอีกฝ่ายหนึ่งล่วงหน้าเป็นลายลักษณ์อักษรไม่น้อยกว่า 14 วัน (สิบสี่วัน)
				</li>
				<li><strong>ผลของการบอกเลิกข้อกำหนดนี้เมื่อมีการบอกเลิกข้อกำหนดนี้ </strong>ท่านจะต้องแจ้งเยลโลไทร์ซึ่งสัญญาผู้ซื้อที่ยังไม่ได้ดำเนินการทั้งหมดโดยสรุป โดยไม่คำนึงถึงเหตุในการบอกเลิกซึ่งข้อกำหนดใดๆ ท่านยังมีความรับผิดชอบในการจัดการสินค้า และ/หรือการติดตั้งสินค้า ซึ่งคำสั่งซื้อที่ยังไม่เสร็จสมบูรณ์ และเยลโลไทร์ (หรือผู้ให้บริการที่เยลโลไทร์กำหนด) จะดำเนินการในหน้าที่ชำระเงินใดๆ ที่ยังคงค้างอยู่ เยลโลไทร์มีดุลพินิจไม่ว่าจะดำเนินการให้การบริการที่ยังไม่สมบูรณ์ให้สำเร็จหรือยกเลิกการบริการดังกล่าว โดยท่านต้องชำระค่าธรรมเนียมใดๆ ที่เกี่ยวข้องกับการบริการที่ถูกดำเนินการจนสมบูรณ์
				</li>
				<li><strong>ข้อกำหนดที่มีผล </strong>ข้อกำหนดใดของข้อกำหนดนี้ โดยลักษณะของข้อกำหนดข้อนั้นเอง จะมีอยู่ต่อไปหากแม้ว่าข้อกำหนดฉบับนี้ยกเลิกไป ให้มีผลบังคับต่อไปหากมีการยกเลิกซึ่งข้อกำหนดนี้
				</li>
				</ol>
				</li>
				<li>
				<strong>เบ็ดเตล็ด</strong>
				<ol>
				<li><strong>สัญญาที่มีผลใช้บังคับ</strong> เว้นแต่ตกลงกันไว้โดยชัดแจ้งไว้เป็นอย่างอื่นระหว่างคู่สัญญา ให้ข้อกำหนดฉบับนี้มีผลบังคับใช้เหนือสัญญาอื่นใด ข้อกำหนดหรือเงื่อนไขเกี่ยวข้องกับสาระสำคัญ การเจรจาก่อนเข้าทำสัญญา และข้อยกเว้นข้อกำหนดอื่นใดทั้งหมดไม่ว่าเสนอโดยคู่สัญญาฝ่ายใด (รวมถึงข้อกำหนดหรือเงื่อนไขใดที่ท่านอ้างที่จะใช้ภายใต้คำสั่งซื้อ การยืนยันคำสั่งซื้อ รายละเอียดเฉพาะสินค้า ใบแจ้งหนี้หรือเอกสารอื่น) และไม่มีข้อกำหนดหรือเงื่อนไขใดได้รับการรับรอง ถูกส่งไปกับหรือมีอยู่ในเอกสารอื่นใดหรืออยู่กับสินค้าจะกลายเป็นส่วนหนึ่งของข้อกำหนดนี้ ข้อกำหนดนี้จะใช้บังคับกับความสัมพันธ์ระหว่างคู่สัญญาเพิ่มเติมจากข้อกำหนดเฉพาะที่ตกลงกันในนี้ หรือที่ตกลงกันเป็นการเฉพาะโดยคู่สัญญาเป็นครั้งคราวไป ในกรณีที่มีข้อขัดแย้งหรือความไม่สอดคล้องระหว่างข้อกำหนดนี้และนโยบาย ให้ข้อกำหนดนี้มีผลใช้บังคับ
				</li>
				<li><strong>การตีความ</strong> คำเอกพจน์ให้หมายความรวมถึงคำพหูพจน์ด้วยและรวมทั้งในทางกลับกันตามเท่าที่บริบทต้องการจะแสดง หัวข้อนั้นถูกใส่ไว้เพื่อความสะดวกเท่านั้นและไม่ต้องใส่ใจเมื่อต้องการจะตีความข้อกำหนด คำว่า “รวมถึง” หรือ “รวมไปถึง” ให้หมายความว่า “รวมถึง โดยไม่จำกัด” เว้นแต่บริบทจะกำหนดไว้เป็นอย่างอื่น ข้อกำหนดตามกฎหมายให้หมายความรวมถึงข้อกำหนดและกฎเกณฑ์ใดที่ทำขึ้นตามข้อกำหนดดังกล่าวเป็นครั้งคราวรวมถึงทั้งที่มีการแก้ไขหรือออกใหม่ ไม่ว่าก่อนหรือหลังวันที่ในข้อกำหนดนี้ และต้องหมายความรวมถึงข้อกฎหมายหรือกฎเกณฑ์ในอดีต (ที่มีการแก้ไขหรือออกใหม่เป็นครั้งคราว) ซึ่งข้อกำหนดหรือกฎเกณฑ์ดังกล่าวที่ถูกแทนที่ไปแล้วไม่ว่าโดยทางตรงหรือทางอ้อม
				</li>
				<li><strong>การสื่อสาร</strong> เว้นแต่มีการระบุไว้เป็นอย่างอื่นในข้อกำหนดนี้หรือมีการตกลงกันไว้ระหว่างคู่สัญญา หนังสือบอกกล่าว คำร้องขอ ข้อเรียกร้องและการสื่อสารอื่นภายใต้ข้อกำหนดนี้จะต้องทำเป็นลายลักษณ์อักษร และให้ถือว่าได้ส่งและรับไว้โดยสมบูรณ์เมื่อได้ส่งไปยังที่อยู่ของผู้รับตามที่ระบุไว้ในข้อกำหนดนี้ หรือที่อยู่อื่นใดตามที่ผู้รับได้แจ้งไว้โดยหนังสือบอกกล่าวแก่คู่สัญญาอีกฝ่ายหนึ่ง โดยบริการขนส่งข้ามคืนที่ได้รับการยอมรับ ไปรษณีย์ลงทะเบียนหรืออีเมล์ เป็นเวลาหนึ่งวันทำการหลังจากทำการฝากส่งด้วยการขนส่งในวันต่อไป เมื่อส่งโดยบริการการขนส่งข้ามคืนที่ได้รับการยอมรับ หรืออีเมล์หรือสามวันทำงานหลังจากได้ส่งไปรษณีย์หรือไปรษณีย์ลงทะเบียน โดยเก็บค่าใช้จ่ายหรือค่าแสตมป์ ล่วงหน้าแล้ว หากเยลโลไทร์ร้องขอ ให้ส่งรายละเอียดสำหรับติดต่อของบุคคลที่เยลโลไทร์ต้องการติดต่อเกี่ยวเนื่องกับความรับผิดชอบของท่านที่เกี่ยวข้องกับข้อกำหนดนี้
				</li>
				<li><strong>การโอนสิทธิ</strong> ท่านไม่สามารถมอบสิทธิ โอนหรือช่วงสิทธิไม่ว่าทั้งหมดหรือบางส่วนซึ่งสิทธิ และ/หรือหน้าที่ของท่านที่เกิดจากข้อกำหนดนี้ โดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรจากเยลโลไทร์ล่วงหน้า เยลโลไทร์สามารถมอบสิทธิโอนหรือช่วงสิทธิไม่ว่าทั้งหมดหรือบางส่วนซึ่งสิทธิ และ/หรือหน้าที่ที่เกิดจากข้อกำหนดนี้ได้
				</li>
				<li><strong>ท่านและเยลโลไทร์เป็นคู่สัญญาที่เป็นอิสระต่อกัน</strong> และไม่มีการใดในข้อกำหนดที่ก่อให้เกิดความเป็นหุ้นส่วน การร่วมทุน ตัวแทน แฟรนไชส์ ความสัมพันธ์เป็นตัวแทนการขายหรือการผูกขาดใดๆ ระหว่างคู่สัญญา ข้อกำหนดนี้ไม่ก่อให้เกิดซึ่งความสัมพันธ์ใดที่เป็นการจ้างงานระหว่างคู่สัญญาหรือกับบุคคลใดที่รับบริการเช่นกัน ท่านไม่มีอำนาจที่จะทำหรือยอมรับข้อเสนอหรือคำรับรองใดในนามของเยลโลไทร์
				</li>
				<li><strong>บุคคลภายนอกไม่มีสิทธิ</strong> ข้อกำหนดนี้และคำรับรอง การรับประกัน ข้อตกลง เงื่อนไข และข้อกำหนดภายใต้ข้อกำหนดนี้มีไว้เพื่อใช้บังคับเพียงและเฉพาะเพื่อผลประโยชน์ของเยลโลไทร์ บริษัทในเครือของเยลโลไทร์และท่าน นอกเหนือจากสิทธิที่ผู้ซื้อมีต่อท่าน ไม่มีข้อกำหนดใดๆ ในข้อกำหนดนี้ที่จะถูกตีความว่าเป็นการให้สิทธิใดๆ แก่บุคคลภายนอกไม่ว่าในกรณีใด
				</li>
				<li><strong>การไม่ชอบด้วยกฎหมาย</strong> โดยไม่คำนึงถึงข้อกำหนดอื่นใดในข้อกำหนดฉบับนี้ไม่มีข้อกำหนดใดในข้อกำหนดนี้ที่ผูกมัดเยลโลไทร์ หรือท่านให้ดำเนินการหรือไม่ดำเนินการใดซึ่งอาจเป็นการต้องห้ามโดยหรือมีโทษภายใต้กฎหมายที่เกี่ยวข้อง ความไม่ชอบกฎหมาย ไม่ถูกต้องหรือการไม่สามารถบังคับใช้ซึ่งข้อกำหนดใดๆ ในข้อกำหนดนี้ภายใต้กฎหมายไม่ว่าในเขตอำนาจใดไม่กระทบซึ่งความถูกต้องตามกฎหมาย ความสมบูรณ์หรือการบังคับใช้ภายใต้กฎหมายของเขตอำนาจใดของข้อกำหนดข้ออื่น ความไม่สมบูรณ์หรือการไม่มีผลบังคับหรือการดังกล่าวที่อาจมีขึ้นในอนาคตของข้อกำหนดใดในข้อกำหนดนี้จะไม่กระทบความสมบูรณ์หรือผลบังคับของเอกสารทั้งฉบับ
				</li>
				<li><strong>โมฆะบางส่วน</strong> หากข้อกำหนดใดในข้อกำหนดฉบับนี้เป็นโมฆะแต่สามารถทำให้มีผลบังคับได้หากลบส่วนใดหรือตัดทอนออก ข้อกำหนดดังกล่าวจะใช้บังคับโดยทำการลบหรือแก้ไขเท่าที่จำเป็นเพื่อให้ข้อกำหนดดังกล่าวนั้นมีสมบูรณ์และบังคับใช้ได้
				</li>
				<li><strong>การไม่ใช้สิทธิที่มีใดๆ </strong>ของคู่สัญญาในกรณีคู่ที่สัญญาอีกฝ่ายละเมิดสัญญาจะไม่ถือเป็นการสละสิทธิของตนภายใต้ข้อกำหนดนี้หรือภายใต้กฎหมายที่เกี่ยวข้อง
				</li>
				<li><strong>เหตุสุดวิสัย</strong> ไม่มีคู่สัญญาฝ่ายใดต้องรับผิดต่อคู่สัญญาอีกฝ่ายหรือถือว่าละเมิดข้อกำหนดนี้ด้วยเหตุการณ์ล่าช้าใดๆ หรือไม่สามารถปฏิบัติหน้าที่ของตนได้เนื่องจากเหตุสุดวิสัย โดยเหตุสุดวิสัยใดๆ ที่เกิดขึ้น ภายใต้ทางเลือกของเยลโลไทร์เอง เยลโลไทร์สามารถเลื่อนการขนส่ง/การดำเนินการตามหน้าที่ของตนภายใต้ข้อกำหนดนี้ไม่ว่าทั้งหมดหรือบางส่วนในระหว่างที่เหตุการณ์หรือสถานการณ์ดังกล่าวเกิดขึ้น หากเหตุการณ์สุดวิสัยใดๆ นั้นดำเนินต่อไปเป็นระยะเวลาเกินสามสิบวัน เยลโลไทร์สามารถแจ้งท่านว่าเยลโลไทร์จะยกเลิกสัญญาฉบับนี้โดยให้มีผลทันทีได้
				</li>
				<li><strong>การแก้ไข</strong> การแก้ไขใดๆ ต่อข้อกำหนดนี้จะไม่สมบูรณ์เว้นแต่มีการตกลงกันอย่างชัดแจ้งเป็นลายลักษณ์อักษร และลงลายมือชื่อโดยผู้แทนที่ได้รับอนุญาตของเยลโลไทร์ หรือมีการบอกกล่าวต่อท่านตามวิธีการบอกกล่าวที่เป็นไปตามข้อกำหนดนี้
				</li>
				<li><strong>อากรแสตมป์</strong> และค่าธรรมเนียมการจดทะเบียนทั้งหมด (ถ้ามี) ในส่วนที่เกี่ยวข้องกับข้อกำหนดนี้ให้ผูกพันและชำระโดยท่านทั้งหมด
				</li>
				<li><strong>กฎหมายที่ใช้บังคับ</strong> กฎหมายใช้บังคับและการระงับข้อพิพาทของข้อกำหนดนี้ให้เป็นไปตามกฏหมายของประเทศไทย
				</li>
				</ol>
				</li>
				</ol>
			`;

			return {
				title: title,
				detail: content
			};
		}
	},
	metaInfo() {
		const title = 'ข้อกำหนดการบริการ (ผู้ขาย) และ/หรือ สัญญาร้านค้า | YELLOWTiRE';
		const desc = 'ข้อกำหนดการบริการ (ผู้ขาย) และ/หรือ สัญญาร้านค้า';
		const image = location.origin + Helper.metaDefault().logo;
		
        return {
            title: title,
            meta: [
				{ vmid: 'author', name: 'author', content: Helper.metaDefault().author },
				{ vmid: 'publisher', name: 'publisher', content: Helper.metaDefault().publisher },
				{ vmid: 'keyword', name: 'keywords', content: Helper.metaDefault().keyword },
                { vmid: 'desc', name: 'description', content: desc },
                { vmid: 'og-url', property: 'og:url', content: location.href },
                { vmid: 'og-title', property: 'og:title', content: title },
                { vmid: 'og-desc', property: 'og:description', content: desc },
                { vmid: 'og-type', property: 'og:type', content: 'website' },
                { vmid: 'og-image', property: 'og:image', content: image },
                { vmid: 'twitter-description', property: 'twitter:description', content: desc },
                { vmid: 'twitter-title', property: 'twitter:title', content: title },
                { vmid: 'twitter-image', property: 'twitter:image', content: image }
            ]
        }
    }
}
</script>